<ub-card *ngIf="isReady()">
  <div title>
    <h3 i18n>Refund is {{ transaction.state }}</h3>
  </div>
  <div title *ngIf="hasError()">
    <eas-payments-error [error]="error"></eas-payments-error>
  </div>
  <div content>
    <ng-container *ngIf="isComplete(); else pendingRefundTemplate">
      <h3 i18n>Amount paid</h3>
      <p>{{ payment.amount | currency: transaction.currency.code }}</p>

      <h3 i18n>Payment method</h3>
      <p>{{ payment.method.name }}</p>

      <h3 i18n>Amount refunded</h3>
      <p>{{ transaction.amount | currency: transaction.currency.code }} </p>
    </ng-container>
    <ng-template #pendingRefundTemplate>
      <h3 i18n>Amount to refund</h3>
      <p>{{ transaction.amount | currency: transaction.currency.code }}</p>

      <h3 i18n>Payment method</h3>
      <p>{{ transaction.method.name }}</p>

      <ub-button-list>
        <button mat-flat-button color="primary" type="button" (click)="onRefund()" i18n>Refund payment</button>
        <button mat-flat-button color="secondary" type="button" (click)="onCancel()" i18n>Close</button>
      </ub-button-list>
    </ng-template>
  </div>
</ub-card>
